import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
interface AchraTabIsotypeProps {
  variant: 'organizations' | 'builders' | 'operators';
  isActive?: boolean;
  className?: string;
}
function AchraTabIsotype(t0) {
  const $ = _c(31);
  const {
    variant,
    isActive,
    className
  } = t0;
  if (variant === "organizations") {
    let t1;
    if ($[0] !== className) {
      t1 = cn("size-7 shrink-0", className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = isActive ? "rgb(5, 130, 255)" : "rgba(5, 130, 255, 0.4)";
    let t3;
    if ($[2] !== t2) {
      t3 = <path d="M 11.783 15.166 C 15.11 15.156 18.302 16.476 20.643 18.829 C 21.207 19.394 21.716 20.011 22.163 20.672 C 22.386 21.002 22.239 21.445 21.871 21.599 L 18.063 23.198 C 17.782 23.317 17.458 23.225 17.261 22.994 C 16.666 22.298 15.943 21.723 15.131 21.298 C 14.098 20.759 12.949 20.48 11.783 20.485 C 9.674 20.475 7.669 21.394 6.305 22.994 C 6.107 23.225 5.784 23.317 5.503 23.198 L 1.695 21.599 C 1.327 21.444 1.179 21.002 1.402 20.672 C 1.849 20.011 2.359 19.394 2.923 18.829 C 5.264 16.476 8.456 15.156 11.783 15.166 Z" fill={t2} />;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <path d="M 5.394 3.222 C 5.399 6.191 3.57 8.857 0.79 9.934 C 0.537 10.026 0.36 10.255 0.335 10.522 L 0.002 14.796 C -0.03 15.214 0.335 15.556 0.747 15.471 C 6.431 14.3 10.706 9.26 10.706 3.222 C 10.706 2.281 10.602 1.364 10.405 0.483 C 10.32 0.101 9.906 -0.099 9.542 0.049 L 5.757 1.589 C 5.464 1.708 5.301 2.018 5.339 2.33 C 5.376 2.622 5.394 2.92 5.394 3.222 Z" fill="rgb(5, 130, 255)" />;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    const t5 = isActive ? "rgb(5, 130, 255)" : "rgba(5, 130, 255, 0.4)";
    let t6;
    if ($[5] !== t5) {
      t6 = <path d="M 18.606 3.222 C 18.601 6.191 20.431 8.857 23.211 9.934 C 23.462 10.03 23.645 10.255 23.665 10.522 L 23.998 14.796 C 24.03 15.214 23.666 15.556 23.254 15.471 C 17.569 14.3 13.294 9.26 13.294 3.222 C 13.294 2.281 13.398 1.364 13.595 0.483 C 13.68 0.101 14.094 -0.099 14.458 0.049 L 18.243 1.589 C 18.536 1.708 18.7 2.018 18.661 2.33 C 18.625 2.626 18.606 2.924 18.606 3.222 Z" fill={t5} />;
      $[5] = t5;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    let t7;
    if ($[7] !== t3 || $[8] !== t6) {
      t7 = <g>{t3}{t4}{t6}</g>;
      $[7] = t3;
      $[8] = t6;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    let t8;
    if ($[10] !== t1 || $[11] !== t7) {
      t8 = <svg className={t1} viewBox="0 0 24 23.25" overflow="visible" aria-hidden={true}>{t7}</svg>;
      $[10] = t1;
      $[11] = t7;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    return t8;
  }
  if (variant === "builders") {
    let t1;
    if ($[13] !== className) {
      t1 = cn("size-7 shrink-0", className);
      $[13] = className;
      $[14] = t1;
    } else {
      t1 = $[14];
    }
    const t2 = isActive ? "rgb(122, 59, 255)" : "rgba(122, 59, 255, 0.4)";
    let t3;
    if ($[15] !== t2) {
      t3 = <path d="M 11.859 14.966 C 15.186 14.956 18.378 16.268 20.719 18.607 C 21.283 19.168 21.792 19.781 22.239 20.438 C 22.462 20.765 22.315 21.206 21.947 21.359 L 18.139 22.949 C 17.858 23.066 17.534 22.975 17.337 22.745 C 16.742 22.054 16.019 21.482 15.207 21.06 C 14.174 20.524 13.025 20.247 11.859 20.252 C 9.75 20.243 7.745 21.155 6.381 22.745 C 6.183 22.975 5.86 23.066 5.579 22.949 L 1.771 21.359 C 1.403 21.205 1.255 20.766 1.478 20.438 C 1.925 19.781 2.435 19.168 2.999 18.607 C 5.34 16.268 8.532 14.956 11.859 14.966 Z M 5.339 2.316 C 5.301 2.005 5.464 1.698 5.757 1.579 L 9.542 0.049 C 9.906 -0.099 10.32 0.1 10.405 0.48 C 10.602 1.356 10.706 2.267 10.706 3.202 C 10.706 9.203 6.431 14.211 0.747 15.375 C 0.335 15.46 -0.03 15.12 0.002 14.704 L 0.335 10.457 C 0.36 10.192 0.537 9.964 0.79 9.872 C 3.57 8.802 5.399 6.152 5.394 3.202 C 5.394 2.902 5.376 2.606 5.339 2.316 Z" fill={t2} />;
      $[15] = t2;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    let t4;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <path d="M 18.606 3.202 C 18.601 6.152 20.431 8.802 23.211 9.872 C 23.462 9.968 23.645 10.192 23.665 10.457 L 23.998 14.704 C 24.03 15.12 23.666 15.46 23.254 15.375 C 17.569 14.211 13.294 9.203 13.294 3.202 C 13.294 2.267 13.398 1.356 13.595 0.48 C 13.68 0.1 14.094 -0.099 14.458 0.049 L 18.243 1.579 C 18.536 1.698 18.7 2.005 18.661 2.316 C 18.625 2.61 18.606 2.906 18.606 3.202 Z" fill="rgb(122, 59, 255)" />;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    let t5;
    if ($[18] !== t3) {
      t5 = <g>{t3}{t4}</g>;
      $[18] = t3;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    let t6;
    if ($[20] !== t1 || $[21] !== t5) {
      t6 = <svg className={t1} viewBox="0 0 24 23" overflow="visible" aria-hidden={true}>{t5}</svg>;
      $[20] = t1;
      $[21] = t5;
      $[22] = t6;
    } else {
      t6 = $[22];
    }
    return t6;
  }
  let t1;
  if ($[23] !== className) {
    t1 = cn("size-7 shrink-0", className);
    $[23] = className;
    $[24] = t1;
  } else {
    t1 = $[24];
  }
  let t2;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M 11.785 15.166 C 15.113 15.156 18.306 16.476 20.647 18.829 C 21.212 19.394 21.721 20.011 22.168 20.672 C 22.391 21.002 22.243 21.445 21.876 21.599 L 18.067 23.198 C 17.786 23.317 17.462 23.225 17.264 22.994 C 16.67 22.298 15.947 21.723 15.134 21.298 C 14.101 20.759 12.951 20.48 11.785 20.485 C 9.676 20.475 7.671 21.394 6.307 22.994 C 6.108 23.225 5.785 23.317 5.504 23.198 L 1.696 21.599 C 1.328 21.444 1.179 21.002 1.402 20.672 C 1.85 20.011 2.359 19.394 2.924 18.829 C 5.265 16.476 8.457 15.156 11.785 15.166 Z" fill="rgb(221, 80, 216)" />;
    $[25] = t2;
  } else {
    t2 = $[25];
  }
  const t3 = isActive ? "rgb(221, 80, 216)" : "rgba(221, 80, 216, 0.4)";
  let t4;
  if ($[26] !== t3) {
    t4 = <g>{t2}<path d="M 5.395 3.222 C 5.4 6.191 3.571 8.857 0.79 9.934 C 0.537 10.026 0.36 10.255 0.335 10.522 L 0.002 14.796 C -0.03 15.214 0.335 15.556 0.747 15.471 C 6.433 14.3 10.708 9.26 10.708 3.222 C 10.708 2.281 10.604 1.364 10.408 0.483 C 10.323 0.101 9.908 -0.099 9.544 0.049 L 5.758 1.589 C 5.466 1.708 5.302 2.018 5.34 2.33 C 5.377 2.622 5.395 2.92 5.395 3.222 Z M 18.66 2.33 C 18.699 2.018 18.535 1.708 18.242 1.589 L 14.456 0.049 C 14.092 -0.099 13.678 0.101 13.592 0.483 C 13.396 1.364 13.292 2.281 13.292 3.222 C 13.292 9.26 17.567 14.3 23.253 15.471 C 23.666 15.556 24.03 15.214 23.998 14.796 L 23.665 10.522 C 23.644 10.255 23.462 10.03 23.211 9.934 C 20.43 8.857 18.6 6.191 18.605 3.222 C 18.605 2.924 18.623 2.626 18.66 2.33 Z" fill={t3} /></g>;
    $[26] = t3;
    $[27] = t4;
  } else {
    t4 = $[27];
  }
  let t5;
  if ($[28] !== t1 || $[29] !== t4) {
    t5 = <svg className={t1} viewBox="0 0 24 24" aria-hidden={true}>{t4}</svg>;
    $[28] = t1;
    $[29] = t4;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  return t5;
}
export { AchraTabIsotype };
export type { AchraTabIsotypeProps };